import { render } from "./ValuesSection.vue?vue&type=template&id=432c2c1e&scoped=true"
import script from "./ValuesSection.vue?vue&type=script&lang=js"
export * from "./ValuesSection.vue?vue&type=script&lang=js"

import "./ValuesSection.vue?vue&type=style&index=0&id=432c2c1e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Liam\\Documents\\werowebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432c2c1e"]])

export default __exports__